const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));

class PromotionItemDTO {
  constructor(input = {}) {
    this.item_id = toString(input.item_id, "");
    this.item_name = toString(input.item_name, "");

    this.affiliation = toString(input.affiliation, "value");
    this.coupon = toString(input.coupon, "value");
    this.discount = toNumber(input.discount, 0);
    this.index = toNumber(input.index, 0);

    this.item_brand = toString(input.item_brand, "value");
    this.item_category = toString(input.item_category, "value");
    this.item_category2 = toString(input.item_category2, "value");
    this.item_category3 = toString(input.item_category3, "value");
    this.item_category4 = toString(input.item_category4, "value");
    this.item_category5 = toString(input.item_category5, "value");

    this.item_list_id = toString(input.item_list_id, "value");
    this.item_list_name = toString(input.item_list_name, "value");
    this.item_variant = toString(input.item_variant, "value");
    this.location_id = toString(input.location_id, "value");

    this.price = toNumber(input.price, 0);
    this.quantity = toNumber(input.quantity, 1);
  }

  toJSON() {
    return {
      item_id: this.item_id,
      item_name: this.item_name,
      affiliation: this.affiliation,
      coupon: this.coupon,
      discount: this.discount,
      index: this.index,
      item_brand: this.item_brand,
      item_category: this.item_category,
      item_category2: this.item_category2,
      item_category3: this.item_category3,
      item_category4: this.item_category4,
      item_category5: this.item_category5,
      item_list_id: this.item_list_id,
      item_list_name: this.item_list_name,
      item_variant: this.item_variant,
      location_id: this.location_id,
      price: this.price,
      quantity: this.quantity,
    };
  }
}

export default class ViewPromotionManualDTO {
  constructor(input = {}) {
    this.promotion_id = toString(input.promotion_id, "value");
    this.creative_name = toString(input.creative_name, "value");
    this.creative_slot = toString(input.creative_slot, "value");
    this.promotion_name = toString(input.promotion_name, "value");

    const items = Array.isArray(input.items) ? input.items : [];
    this.items = items.map((it) => new PromotionItemDTO(it).toJSON());
  }

  addItem(item) {
    this.items.push(new PromotionItemDTO(item).toJSON());
    return this;
  }

  toJSON() {
    return {
      promotion_id: this.promotion_id,
      creative_name: this.creative_name,
      creative_slot: this.creative_slot,
      promotion_name: this.promotion_name,
      items: this.items,
    };
  }

  isValid() {
    // اختياري: تحقق بسيط
    return (
      this.promotion_id.trim() !== "" &&
      this.promotion_name.trim() !== "" &&
      Array.isArray(this.items) &&
      this.items.length > 0
    );
  }
}
